'use strict';

/**
 * Application Management Constants.
 * @readonly
 */
var APPLICATIONS = ['REVENUE_OPTIMIZER', 'DYNAMIC_AVAILABILITY', 'FARES_OPTIMIZER'];
var ApplicationManagementConstants = {
  APPLICATIONS: APPLICATIONS
};
module.exports = ApplicationManagementConstants;